import React from 'react';

interface DailyStreakBannerProps {
  streak: number;
}

const MILESTONES = [3, 7, 14, 30];

const DailyStreakBanner: React.FC<DailyStreakBannerProps> = ({ streak }) => {
  if (streak <= 0) return null;

  return (
    <div className="daily-streak-banner">
      <span className="streak-flame fire-glow">&#128293;</span>
      <span className="streak-count">{streak} day streak</span>
      <div className="streak-milestones">
        {MILESTONES.map((m) => (
          <span
            key={m}
            className={`streak-milestone-dot ${streak >= m ? 'milestone-reached' : ''}`}
            title={`${m} days`}
          >
            {m}
          </span>
        ))}
      </div>
    </div>
  );
};

export default DailyStreakBanner;
